import "./icons";


require(`!!file-loader?name=[name].[ext]!./mockup.png`);  
require(`!!file-loader?name=[name].[ext]!./app-store-badge.svg`); 
require(`!!file-loader?name=[name].[ext]!./google-play-badge.svg`); 
require(`!!file-loader?name=[name].[ext]!./logo-with-title-white.svg`); 
require(`!!file-loader?name=[name].[ext]!./logo-with-title-black.svg`); 
require(`!!file-loader?name=[name].[ext]!./check-marked.svg`); 